import { css } from '@/styled-system/css';

export const pageContainer = css({
  background: 'bg.neutral',
  color: 'text.neutral',
  minHeight: 'svh',
  paddingBlock: 'looser',
  paddingInline: 'default',
});

export const contentWrapper = css({
  width: '100%',
  maxWidth: '1280px',
  marginInline: 'auto',
});

export const textColumn = css({
  order: 1,
  width: '100%',
  maxWidth: 'breakpoint-lg',
  minWidth: 'zero',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  lg: {
    order: 0,
    flex: '1 1 auto',
  },
});

export const topSection = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: {
    base: 'loose',
    lg: 'looser',
  },
  lg: {
    flexDirection: 'row',
  },
});

export const artworkFrame = css({
  order: 0,
  width: '100%',
  maxWidth: 'breakpoint-lg',
  minWidth: 'zero',
  justifySelf: {
    base: 'center',
    lg: 'end',
  },
  lg: {
    order: 1,
    flex: '1 1 auto',
  },
});

export const artwork = css({
  display: 'block',
  width: '100%',
  height: 'auto',
});

export const heroSection = css({
  order: 0,
  textAlign: 'center',
  lg: {
    textAlign: 'left',
  },
});

export const heading = css({
  color: 'text.neutral',
  marginBottom: 'tighter',
});

export const subtext = css({
  margin: 'zero',
});

export const searchSection = css({
  order: 2,
  width: '100%',
  maxWidth: 'breakpoint-lg',
  marginInline: 'auto',
  lg: {
    marginInline: 'zero',
  },
});

export const searchWrapper = css({
  width: '100%',
  marginTop: 'loose',
  padding: 'tighter',
  borderRadius: 'pill',
  backgroundColor: 'bg.action.neutral.alt.default',
  boxShadow: 'sm',
});

export const columnsRow = css({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr)',
  gap: 'loose',
  marginTop: 'looser',
  paddingTop: 'loose',
  md: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 'looser',
  },
});

export const subColumn = css({
  minWidth: 'zero',
});

export const subColumnHeading = css({
  color: 'text.neutral',
  marginBottom: 'tighter',
});

export const linkList = css({
  listStyle: 'none',
  margin: 'zero',
  padding: 'zero',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'tighter',
});

export const cityLink = css({
  display: 'inline-flex',
});

export const nearMeLinksNav = css({
  marginTop: 'loose',
});

export const nearMeLinksList = css({
  listStyle: 'none',
  margin: 'zero',
  padding: 'zero',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '150',
  lg: {
    justifyContent: 'flex-start',
  },
});

export const nearMeLink = css({
  display: 'inline-flex',
  alignItems: 'center',
  paddingInline: '250',
  paddingBlock: '150',
  borderRadius: 'pill',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.neutral',
  backgroundColor: 'bg.neutral',
  color: 'text.neutral',
  fontSize: 'body-xs',
  fontWeight: 'regular',
  textDecoration: 'none',
  _hover: {
    borderColor: 'brand.primary',
    backgroundColor: 'bg.action.neutral.alt.hover',
  },
  _active: {
    backgroundColor: 'bg.action.neutral.alt.pressed',
  },
  _focusVisible: {
    boxShadow: 'focus',
  },
});

export const otherLink = css({
  display: 'flex',
  width: 'fit-content',
  marginBottom: 'tighter',
});
